<template src="./FormStep2.html"></template>
<style lang="scss" src="./FormStep2.scss"></style>
<script>
import _ from 'lodash'

export default {
  name: 'FormStep2',

  data () {
    return {
      citiesRes: [],
      citiesRecap: [],
      citiesForn: [],
      errors: [],
      prelievoTipi: [],
      values: {
        Consumo: '',
        IndirizzoSpedizioneBolletta: true,
        Nom_Recap: '',
        Top_Recap: '',
        Via_Recap: '',
        Civ_Recap: '',
        Suf_Recap: '',
        Cap_Recap: '',
        Com_Recap: '',
        Prov_Recap: '',
        Forn_Attuale: '',
        Prelievo: '',
        Provenienza: '', // MERCATO TUTELATO, MERCATO LIBERO
        Pod_Pdr: '',
        Potenza: '',
        SedeLegaleFornitura: true,
        Via_Res: '',
        Civ_Res: '',
        Com_Res: '',
        Prov_Res: '',
        Suf_Res: '',
        ResidenzaAnagrafica: 'SI',
        Top_Res: '',
        Cap_Res: '',
        Ind_Forn: '',
        Civ_Forn: '',
        Com_Forn: '',
        Prov_Forn: '',
        Suf_Forn: '',
        Top_Forn: '',
        Cap_Forn: ''
      }
    }
  },

  computed: {
    displayRecap() {
      // values.ResidenzaAnagrafica === 'non residente' || values.IndirizzoSpedizioneBolletta === false
      return !this.values.IndirizzoSpedizioneBolletta
    },

    displayRes() {
      return this.values.ResidenzaAnagrafica === 'NO' || this.values.SedeLegaleFornitura === false
    },

    form() {
      return this.$store.state.form
    },

    formValues() {
      return this.$store.state.form.values
    },

    provinces() {
      return this.$store.state.provinces
    },

    strings() {
      return this.$store.state.strings
    },

    sellers() {
      return this.$store.state.sellers
    },

    svg() {
      return this.$store.state.svg
    },

    token() {
      return this.$store.state.token
    }
  },

  watch: {
    citiesForn(value) {
      // reset forn city and cap
      if (value.length === 0) {
        this.values.Com_Forn = ''
        this.values.Cap_Forn = ''
      }
    },

    citiesRecap(value) {
      // reset forn city and cap
      if (value.length === 0) {
        this.values.Com_Recap = ''
        this.values.Com_Recap = ''
      }
    },

    citiesRes(value) {
      // reset forn city and cap
      if (value.length === 0) {
        this.values.Com_Res = ''
        this.values.Cap_Res = ''
      }
    },

    formValues() {
      this.$updateValuesFromStore()
    },

    'values.Top_Forn'(value) {
      if (!this.displayRes) {
        this.values.Top_Res = value
      }
    },

    'values.Ind_Forn'(value) {
      if (!this.displayRes) {
        this.values.Via_Res = value
      }
    },

    'values.Civ_Forn'(value) {
      if (!this.displayRes) {
        this.values.Civ_Res = value
      }
    },

    'values.Suf_Forn'(value) {
      if (!this.displayRes) {
        this.values.Suf_Res = value
      }
    },

    'values.Cap_Forn'(value) {
      if (!this.displayRes) {
        this.values.Cap_Res = value
      }
    },

    'values.Com_Forn'(value) {
      const city = this.citiesForn.filter(city => city.comune === value)[0]
      if (city && city.cap) {
        this.values.Cap_Forn = city.cap
      } else {
        this.values.Cap_Forn = ''
      }

      if (!this.displayRes) {
        this.values.Com_Res = value
      }
    },

    'values.Com_Recap'(value) {
      const city = this.citiesRecap.filter(city => city.comune === value)[0]
      if (city && city.cap) {
        this.values.Cap_Recap = city.cap
      } else {
        this.values.Cap_Recap = ''
      }
    },

    'values.Com_Res'(value) {
      const city = this.citiesRes.filter(city => city.comune === value)[0]
      if (city && city.cap) {
        this.values.Cap_Res = city.cap
      } else {
        this.values.Cap_Res = ''
      }
    },

    'values.Prov_Forn'(value) {
      this.getCities(value).then(data => { this.citiesForn = (data && data.length) ? data : [] })

      if (!this.displayRes) {
        this.values.Prov_Res = value
      }
    },

    'values.Prov_Recap'(value) {
      this.getCities(value).then(data => { this.citiesRecap = (data && data.length) ? data : [] })
    },

    'values.Prov_Res'(value) {
      this.getCities(value).then(data => { this.citiesRes = (data && data.length) ? data : [] })
    }
  },

  mounted() {
    if (this.form.type === 'gas-dom') {
      this.prelievoTipi = ['C1', 'C2', 'C3']
    }
    if (this.form.type === 'gas-au') {
      this.prelievoTipi = ['C1', 'C2', 'C3', 'T1', 'T2']
    }

    this.$updateValuesFromStore()
  },

  methods: {
    getCities(province) {
      const provinceObj = this.provinces.filter(prov => prov.provCod === province)[0]
      if (provinceObj && provinceObj.provCod) {
        return this.$apiCall(`/StepFunnelWeb/GetListComuni?codiceProvincia=${provinceObj.provCod}`)
      } else {
        return Promise.resolve([])
      }
    },

    querySearch(queryString, cb) {
      let results = queryString ? this.sellers.filter(str => str.toLowerCase().indexOf(queryString.toLowerCase()) === 0) : this.sellers
      results = results.map(result => ({
        link: result,
        value: result
      }))
      cb(results)
    },

    queryProvinces(queryString, cb) {
      let results = queryString ? this.provinces.filter(prov => prov.provDescrizione.toUpperCase().indexOf(queryString.toUpperCase()) === 0) : this.provinces
      results = results.map(prov => ({
        name: prov.provDescrizione,
        value: prov.provCod
      }))
      cb(results)
    },

    queryFornCities(queryString, cb) {
      let results = queryString ? this.citiesForn.filter(city => city.comune.toUpperCase().indexOf(queryString.toUpperCase()) === 0) : this.citiesForn
      results = results.map(city => ({
        value: city.comune
      }))
      cb(results)
    },

    queryResCities(queryString, cb) {
      let results = queryString ? this.citiesRes.filter(city => city.comune.toUpperCase().indexOf(queryString.toUpperCase()) === 0) : this.citiesRes
      results = results.map(city => ({
        value: city.comune
      }))
      cb(results)
    },

    queryRecapCities(queryString, cb) {
      let results = queryString ? this.citiesRecap.filter(city => city.comune.toUpperCase().indexOf(queryString.toUpperCase()) === 0) : this.citiesRecap
      results = results.map(city => ({
        value: city.comune
      }))
      cb(results)
    },

    saveAndRedirect() {
      let objToken = JSON.parse(localStorage.getItem('agsmToken'))
      objToken.retrieveData = true
      localStorage.setItem('agsmToken', JSON.stringify(objToken))
      window.location.href = this.$store.state.saveAndRedirectUrl
    },

    submit () {
      this.validation()
      if (this.token && !this.errors.length) {
        let data = {
          tokenId: this.token,
          step: 2,
          fields: _.map(this.values, (valueField, field) => {
            if (field === 'Potenza') {
              valueField = this.values.Potenza.replace(/\./g, ',')
            }
            if (field === 'Consumo') {
              valueField = this.values.Consumo.replace(/\./g, ',')
            }
            return {
              field,
              valueField : valueField === null ? '' : valueField
            }
          })
        }
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))

        this.$apiCall('/StepFunnelWeb/AddDataStepFunnel', {
          method: 'POST',
          body: formData
        }).then(data => {
          if (data && data.status && data.status === 200) {
            this.$store.commit('formValues', this.values)
            this.$store.commit('formIndex', 2)
          } else {
            alert("Si sono verificati degli errori")
          }
        })
      }
    },

    validation () {
      const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      const numericRegex = /^\d+$/
      const podRegex = /^[I|i][T|t][0-9]{3}[E|e][0-9]{7}[a-zA-Z0-9]$/
      const pdrRegex = /^[0-9]{14}$/
      const zipRegex = /^[0-9]{5}$/
      const provinces = this.provinces.map(prov => prov.provCod)
      const citiesForn = this.citiesForn.map(city => city.comune)
      const citiesRes = this.citiesRes.map(city => city.comune)
      const citiesRecap = this.citiesRecap.map(city => city.comune)
      let fields = []

      this.errors = []

      if (this.form.type === 'ee-dom') {
        fields = ['Forn_Attuale', 'Pod_Pdr', 'Potenza', 'Consumo', 'Top_Forn', 'Ind_Forn', 'Civ_Forn', 'Cap_Forn', 'Com_Forn', 'Prov_Forn', 'Provenienza']
        if (this.values.ResidenzaAnagrafica === 'NO') {
          fields = _.concat(fields, ['Top_Res', 'Via_Res', 'Civ_Res', 'Cap_Res', 'Com_Res', 'Prov_Res'])
        }
        if (this.displayRecap) {
          fields = _.concat(fields, ['Nom_Recap', 'Top_Recap', 'Via_Recap', 'Civ_Recap', 'Cap_Recap', 'Com_Recap', 'Prov_Recap'])
        }
      }

      if (this.form.type === 'ee-au') {
        fields = ['Forn_Attuale', 'Pod_Pdr', 'Potenza', 'Consumo', 'Top_Forn', 'Ind_Forn', 'Civ_Forn', 'Cap_Forn', 'Com_Forn', 'Prov_Forn', 'Provenienza']
        if (!this.values.SedeLegaleFornitura) {
          fields = _.concat(fields, ['Top_Res', 'Via_Res', 'Civ_Res', 'Cap_Res', 'Com_Res', 'Prov_Res'])
        }
        if (this.displayRecap) {
          fields = _.concat(fields, ['Nom_Recap', 'Top_Recap', 'Via_Recap', 'Civ_Recap', 'Cap_Recap', 'Com_Recap', 'Prov_Recap'])
        }
      }

      if (this.form.type === 'gas-dom') {
        fields = ['Forn_Attuale', 'Pod_Pdr', 'Prelievo', 'Consumo', 'Top_Forn', 'Ind_Forn', 'Civ_Forn', 'Cap_Forn', 'Com_Forn', 'Prov_Forn', 'Provenienza']
        if (this.values.ResidenzaAnagrafica === 'NO') {
          fields = _.concat(fields, ['Top_Res', 'Via_Res', 'Civ_Res', 'Cap_Res', 'Com_Res', 'Prov_Res'])
        }
        if (this.displayRecap) {
          fields = _.concat(fields, ['Nom_Recap', 'Top_Recap', 'Via_Recap', 'Civ_Recap', 'Cap_Recap', 'Com_Recap', 'Prov_Recap'])
        }
      }

      if (this.form.type === 'gas-au') {
        fields = ['Forn_Attuale', 'Pod_Pdr', 'Prelievo', 'Consumo', 'Top_Forn', 'Ind_Forn', 'Civ_Forn', 'Cap_Forn', 'Com_Forn', 'Prov_Forn', 'Provenienza']
        if (!this.values.SedeLegaleFornitura) {
          fields = _.concat(fields, ['Top_Res', 'Via_Res', 'Civ_Res', 'Cap_Res', 'Com_Res', 'Prov_Res'])
        }
        if (this.displayRecap) {
          fields = _.concat(fields, ['Nom_Recap', 'Top_Recap', 'Via_Recap', 'Civ_Recap', 'Cap_Recap', 'Com_Recap', 'Prov_Recap'])
        }
      }

      fields.forEach(field => {
        if (field === 'Forn_Attuale' && !this.values.Forn_Attuale) {
          this.errors.push('Forn_Attuale')
        } else if (field === 'Forn_Attuale' && !this.sellers.includes(this.values.Forn_Attuale)) {
          this.errors.push('Forn_Attuale')
        }

        if (field === 'Pod_Pdr' && ['ee-au', 'ee-dom'].includes(this.form.type) && !this.values.Pod_Pdr.toUpperCase().match(podRegex)) {
          this.errors.push('Pod_Pdr')
        }

        if (field === 'Pod_Pdr' && ['gas-au', 'gas-dom'].includes(this.form.type) && !this.values.Pod_Pdr.match(pdrRegex)) {
          this.errors.push('Pod_Pdr')
        }

        if (field === 'Potenza' && (!this.values.Potenza || parseFloat(this.values.Potenza.replace(/\,/, '.')) <= 0)) {
          this.errors.push('Potenza')
        }

        if (field === 'Consumo' && ['ee-au', 'ee-dom'].includes(this.form.type) && !this.values.Consumo) {
          this.errors.push('Consumo')
        } else if (field === 'Consumo' && this.values.Consumo.match(/\,|\./)) {
          this.errors.push('Consumo')
        }

        if (field === 'Consumo' && ['gas-au', 'gas-dom'].includes(this.form.type) && !this.values.Consumo) {
          this.errors.push('Consumo')
        } else if (field === 'Consumo' && this.values.Consumo.match(/\,|\./)) {
          this.errors.push('Consumo')
        }

        if (field === 'Top_Forn' && !this.values.Top_Forn) {
          this.errors.push('Top_Forn')
        }

        if (field === 'Ind_Forn' && !this.values.Ind_Forn) {
          this.errors.push('Ind_Forn')
        }

        if (field === 'Civ_Forn' && !this.values.Civ_Forn.match(numericRegex)) {
          this.errors.push('Civ_Forn')
        }
        
        if (field === 'Cap_Forn' && !this.values.Cap_Forn.match(zipRegex)) {
          this.errors.push('Cap_Forn')
        } else if (field === 'Cap_Forn') {
          const city = this.citiesForn.filter(city => city.comune === this.values.Com_Forn)[0] 
          if (city && city.cap) {
            if (this.values.Cap_Forn.indexOf(city.cap) !== 0) {
              // zip not match
              this.errors.push('Cap_Forn')
            }
          } else {
            // no city found
            this.errors.push('Cap_Forn')
          }
        }

        if (field === 'Com_Forn' && !this.values.Com_Forn) {
          this.errors.push('Com_Forn')
        } else if (field === 'Com_Forn' && !citiesForn.includes(this.values.Com_Forn)) {
          this.errors.push('Com_Forn')
        }

        if (field === 'Prov_Forn' && !this.values.Prov_Forn) {
          this.errors.push('Prov_Forn')
        } else if (field === 'Prov_Forn' && !provinces.includes(this.values.Prov_Forn)) {
          this.errors.push('Prov_Forn')
        }

        if (field === 'Top_Res' && !this.values.Top_Res) {
          this.errors.push('Top_Res')
        }

        if (field === 'Via_Res' && !this.values.Via_Res) {
          this.errors.push('Via_Res')
        }

        if (field === 'Civ_Res' && !this.values.Civ_Res.match(numericRegex)) {
          this.errors.push('Civ_Res')
        }

        if (field === 'Cap_Res' && !this.values.Cap_Res.match(zipRegex)) {
          this.errors.push('Cap_Res')
        } else if (field === 'Cap_Forn') {
          const city = this.citiesRes.filter(city => city.comune === this.values.Com_Res)[0] 
          if (city && city.cap) {
            if (this.values.Cap_Res.indexOf(city.cap) !== 0) {
              // zip not match
              this.errors.push('Cap_Res')
            }
          } else {
            // no city found
            this.errors.push('Cap_Res')
          }
        }

        if (field === 'Com_Res' && !this.values.Com_Res) {
          this.errors.push('Com_Res')
        } else if (field === 'Com_Res' && !citiesRes.includes(this.values.Com_Res)) {
          this.errors.push('Com_Res')
        }

        if (field === 'Prov_Res' && !this.values.Prov_Res) {
          this.errors.push('Prov_Res')
        } else if (field === 'Prov_Res' && !provinces.includes(this.values.Prov_Res)) {
          this.errors.push('Prov_Res')
        }

        if (field === 'Provenienza' && this.values.Provenienza === null) {
          this.errors.push('Provenienza')
        }

        if (field === 'Prelievo' && !this.values.Prelievo) {
          this.errors.push('Prelievo')
        }

        if (field === 'Nom_Recap' && !this.values.Nom_Recap) {
          this.errors.push('Nom_Recap')
        }

        if (field === 'Top_Recap' && !this.values.Top_Recap) {
          this.errors.push('Top_Recap')
        }

        if (field === 'Via_Recap' && !this.values.Via_Recap) {
          this.errors.push('Via_Recap')
        }

        if (field === 'Civ_Recap' && !this.values.Civ_Recap.match(numericRegex)) {
          this.errors.push('Civ_Recap')
        }

        if (field === 'Cap_Recap' && !this.values.Cap_Recap.match(zipRegex)) {
          this.errors.push('Cap_Recap')
        } else if (field === 'Cap_Recap') {
          const city = this.citiesRecap.filter(city => city.comune === this.values.Com_Recap)[0] 
          if (city && city.cap) {
            if (this.values.Cap_Recap.indexOf(city.cap) !== 0) {
              // zip not match
              this.errors.push('Cap_Recap')
            }
          } else {
            // no city found
            this.errors.push('Cap_Recap')
          }
        }

        if (field === 'Com_Recap' && !this.values.Com_Recap) {
          this.errors.push('Com_Recap')
        } else if (field === 'Com_Recap' && !citiesRecap.includes(this.values.Com_Recap)) {
          this.errors.push('Com_Recap')
        }

        if (field === 'Prov_Recap' && !this.values.Prov_Recap) {
          this.errors.push('Prov_Recap')
        } else if (field === 'Prov_Recap' && !provinces.includes(this.values.Prov_Recap)) {
          this.errors.push('Prov_Recap')
        }
      })

      // test chiara offer
      if (this.form.values.Prodotto === "Chiara" && this.values.Prov_Forn !== "VR" && !this.errors.includes("Prov_Forn")) {
          this.errors.push("Prov_Forn");
      }
    },

    copyResidenceToBillDelivery () {
      this.values.Top_Recap = this.values.Top_Res
      this.values.Via_Recap = this.values.Via_Res
      this.values.Civ_Recap = this.values.Civ_Res
      this.values.Cap_Recap = this.values.Cap_Res
      this.values.Com_Recap = this.values.Com_Res
      this.values.Prov_Recap = this.values.Prov_Res
    },

    // copyRegisteredOfficeToBillDelivery () {
    //     this.values.Top_Recap = this.values.registeredOfficeToponym
    //     this.values.Via_Recap = this.values.registeredOfficeAddress
    //     this.values.Civ_Recap = this.values.registeredOfficeCivicNumber
    //     this.values.Cap_Recap = this.values.registeredOfficeZip
    //     this.values.Com_Recap = this.values.registeredOfficeMunicipality
    //     this.values.Prov_Recap = this.values.registeredOfficeProvince
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormStep2/FormStep2.vue